import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { IUserProfileActions } from ".";
import { initialCommision, initialSecurityGroup, initialUserProfileState } from "./userprofileState";
import {
  FETCH_USERS_FAILED,
  FETCH_USERS_LIST_FAILED,
  FETCH_USERS_LIST_PROGRESS,
  FETCH_USERS_LIST_SUCCESS,
  FETCH_MY_PROFILE_FAILED,
  FETCH_MY_PROFILE_PROGRESS,
  FETCH_MY_PROFILE_SUCCESS,
  FETCH_USERS_PROGRESS,
  FETCH_USERS_SUCCESS,
  CLEAR_MY_PROFILE,
  FETCH_USERS_SECURITY_GROUP_PROGRESS,
  FETCH_USERS_SECURITY_GROUP_SUCCESS,
  FETCH_USERS_SECURITY_GROUP_FAILED,
  FETCH_USERS_COMMISSION_PROGRESS,
  FETCH_USERS_COMMISSION_SUCCESS,
  FETCH_USERS_COMMISSION_FAILED,
  FETCH_USERS_COMMISSION_LIST_PROGRESS,
  FETCH_USERS_COMMISSION_LIST_SUCCESS,
  FETCH_USERS_COMMISSION_LIST_FAILED,
  FETCH_CONTINUING_EDUCATION_LIST_PROGRESS,
  FETCH_CONTINUING_EDUCATION_LIST_SUCCESS,
  FETCH_CONTINUING_EDUCATION_LIST_FAILED,
  FETCH_USER_PROFILE_DOCUMENTS_LIST_PRGRESS,
  FETCH_USER_PROFILE_DOCUMENTS_LIST_SUCCESS,
  FETCH_USER_PROFILE_DOCUMENTS_LIST_FAILED,
  CHANGE_USER_EMAIL,
  FETCH_USER_LICENSE_LIST_PROGRESS,
  FETCH_USER_LICENSE_LIST_SUCCESS,
  FETCH_USER_LICENSE_LIST_FAILED,
} from "./userProfileActions";

export const UserProfileReducer = (
  state: IStoreState["userprofile"] = initialUserProfileState,
  action: IUserProfileActions
) => {
  switch (action.type) {
    case FETCH_USERS_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.users.loading = LoadState.InProgress;
        draftState.users.totalNumberOfRecords = 0;
        draftState.users.data = [];
      });
      return newState;
    }
    case FETCH_USERS_LIST_SUCCESS: {
      const { data, totalNumberOfRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.users.loading = LoadState.Loaded;
        draftState.users.totalNumberOfRecords = totalNumberOfRecords;
        draftState.users.data = data;
      });
      return newState;
    }
    case FETCH_USERS_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.users.loading = LoadState.Failed;
        draftState.users.totalNumberOfRecords = 0;
        draftState.users.data = [];
      });
      return newState;
    }
    case CHANGE_USER_EMAIL: {
      const {new_email, user_fact_id} = action.payload;
          const newState = produce(state, (draftState) => {
         const item = draftState.users.data.find(x=>x.user_fact_id === user_fact_id);
         if(item){
          item.email = new_email;
         }
      });
      return newState;
    }
    case FETCH_USERS_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.users.userLoading = LoadState.InProgress;
        draftState.users.user = initialUserProfileState["users"]["user"];
      });
      return newState;
    }
    case FETCH_USERS_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.users.userLoading = LoadState.Loaded;
        draftState.users.user = data;
      });
      return newState;
    }
    case FETCH_USERS_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.users.userLoading = LoadState.Failed;
        draftState.users.error = errorMessage;
      });
      return newState;
    }
    case FETCH_MY_PROFILE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.userProfileLoading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_MY_PROFILE_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.userProfileLoading = LoadState.Loaded;
        draftState.userProfile = data;
      });
      return newState;
    }
    case FETCH_MY_PROFILE_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.userProfileLoading = LoadState.Failed;
      });
      return newState;
    }
    case FETCH_USERS_SECURITY_GROUP_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.userSecurityGroup.loading = LoadState.InProgress;
        draftState.userSecurityGroup.data = initialSecurityGroup;
      });
      return newState;
    }
    case FETCH_USERS_SECURITY_GROUP_SUCCESS: {
      const {data} = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.userSecurityGroup.loading = LoadState.Loaded;
        draftState.userSecurityGroup.data = data;
      });
      return newState;
    }
    case FETCH_USERS_SECURITY_GROUP_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.userSecurityGroup.loading = LoadState.Failed;
        draftState.userSecurityGroup.data = initialSecurityGroup;
      });
      return newState;
    }

    case FETCH_USERS_COMMISSION_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.commission.loading = LoadState.InProgress;
        draftState.commission.list = [];
        draftState.commission.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_USERS_COMMISSION_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.commission.loading = LoadState.Loaded;
        draftState.commission.list = list;
        draftState.commission.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_USERS_COMMISSION_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.commission.loading = LoadState.InProgress;
        draftState.commission.list = [];
        draftState.commission.totalRecords = 0;
      });
      return newState;
    }

    case FETCH_USERS_COMMISSION_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.commission.loading = LoadState.InProgress;
        draftState.commission.data = initialCommision;
      });
      return newState;
    }
    case FETCH_USERS_COMMISSION_SUCCESS: {
      const {data} = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.commission.loading = LoadState.Loaded;
        draftState.commission.data = data;
      });
      return newState;
    }
    case FETCH_USERS_COMMISSION_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.commission.loading = LoadState.Failed;
        draftState.commission.data = initialCommision;
      });
      return newState;
    }

    case FETCH_CONTINUING_EDUCATION_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.continuingEducation.loading = LoadState.InProgress;
        draftState.continuingEducation.list = [];
        draftState.continuingEducation.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_CONTINUING_EDUCATION_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.continuingEducation.loading = LoadState.Loaded;
        draftState.continuingEducation.list = list;
        draftState.continuingEducation.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_CONTINUING_EDUCATION_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.continuingEducation.loading = LoadState.Failed;
        draftState.continuingEducation.list = [];
        draftState.continuingEducation.totalRecords = 0;
      });
      return newState;
    }

    case FETCH_USER_LICENSE_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.userLicense.loading = LoadState.InProgress;
        draftState.userLicense.list = [];
        draftState.userLicense.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_USER_LICENSE_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.userLicense.loading = LoadState.Loaded;
        draftState.userLicense.list = list;
        draftState.userLicense.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_USER_LICENSE_LIST_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.userLicense.loading = LoadState.Failed;
        draftState.userLicense.list = [];
        draftState.userLicense.totalRecords = 0;
        draftState.userLicense.error = errorMessage;
      });
      return newState;
    }

    case FETCH_USER_PROFILE_DOCUMENTS_LIST_PRGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.documents.loading = LoadState.InProgress;
        draftState.documents.list = [];
      });
      return newState;
    }
    case FETCH_USER_PROFILE_DOCUMENTS_LIST_SUCCESS: {
      const {data} = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.documents.loading = LoadState.Loaded;
        draftState.documents.list = data;
      });
      return newState;
    }
    case FETCH_USER_PROFILE_DOCUMENTS_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.documents.loading = LoadState.Failed;
        draftState.documents.list = [];
      });
      return newState;
    }
    case CLEAR_MY_PROFILE: {
      const newState = produce(state, (draftState) => {
        draftState.userProfileLoading = LoadState.NotLoaded;
        draftState.userProfile = initialUserProfileState["userProfile"];
      });
      return newState;
    }
    default: {
      return state;
    }
  }
};
